import React from 'react'
import Footer from '../../../Footer/Footer'
import IMAGES from '../../../Images'
import Navbar from '../../../Navbar/Navbar'
import { NavLink } from 'react-router-dom'

export const Asg_overview = () => {
  return (
    <>
    <Navbar/>
        <section className='template'>
            <div className='template-container container'>
            <h1>Auto Scaling Group</h1>
            <h2>Overview</h2>
            <img src={IMAGES.AWS309} alt="" />          
            <img src={IMAGES.AWS310} alt="" />          
            <img src={IMAGES.AWS311} alt="" />          
            <img src={IMAGES.AWS312} alt="" />          
            <img src={IMAGES.AWS313} alt="" />          
            <img src={IMAGES.AWS314} alt="" />          
            <img src={IMAGES.AWS315} alt="" />          
            <img src={IMAGES.AWS316} alt="" />                      
            </div>
            <div className='template-buttons container'>
            <NavLink to="/glb_info"><button className='template-back'>Back</button></NavLink>
            <NavLink to="/con_autoscaling"><button className='template-next'>Next</button></NavLink>
            </div>
       </section>
       <Footer/>
    </>
    
  )
}
